var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 71.0694H10.59C7.96002 71.0694 4.00002 70.0694 2.05002 67.2694C0.250024 64.6194 1.23002 59.9594 2.63002 57.4194C10.48 43.2694 18.09 27.1294 29.19 5.99944C30.93 2.69944 33.49 1.11944 36 1.06944C38.51 1.01944 41.14 2.69944 42.88 5.99944C54 27.1294 61.59 43.2694 69.44 57.4194C70.84 59.9594 71.82 64.6194 70.02 67.2694C68.02 70.1094 64.11 71.0694 61.48 71.0694H36Z",
    stroke: "#FF033D",
    strokeWidth: 2.14,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.04 62.7093C37.7465 62.7093 39.13 61.3259 39.13 59.6193C39.13 57.9127 37.7465 56.5293 36.04 56.5293C34.3334 56.5293 32.95 57.9127 32.95 59.6193C32.95 61.3259 34.3334 62.7093 36.04 62.7093Z",
    fill: "#FF033D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0001 16.421C35.1963 16.4444 34.4333 16.7802 33.8731 17.3572C33.3129 17.9342 32.9998 18.7068 33.0001 19.511V48.821C32.9762 49.2409 33.0383 49.6612 33.1825 50.0563C33.3267 50.4514 33.5501 50.8129 33.8389 51.1186C34.1277 51.4243 34.4759 51.6679 34.8621 51.8344C35.2484 52.0008 35.6645 52.0867 36.0851 52.0867C36.5057 52.0867 36.9219 52.0008 37.3081 51.8344C37.6943 51.6679 38.0425 51.4243 38.3313 51.1186C38.6202 50.8129 38.8435 50.4514 38.9878 50.0563C39.132 49.6612 39.194 49.2409 39.1701 48.821V19.511C39.1703 19.0984 39.0878 18.6899 38.9275 18.3097C38.7672 17.9295 38.5324 17.5852 38.237 17.2972C37.9415 17.0092 37.5914 16.7833 37.2072 16.6328C36.823 16.4823 36.4126 16.4103 36.0001 16.421Z",
    fill: "#FF033D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.07,
    height: 72.14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.277af0f45bd9aabb2c6692de2942f948.svg";
export { ForwardRef as ReactComponent };